import { render, staticRenderFns } from "./CameraResetDialog.vue?vue&type=template&id=4ded7abf&scoped=true"
import script from "./CameraResetDialog.vue?vue&type=script&lang=js"
export * from "./CameraResetDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ded7abf",
  null
  
)

export default component.exports